import { createContext, useContext, useState, type ReactNode } from "react";

interface RegisterModalContextValue {
  open: boolean;
  openModal: () => void;
  closeModal: () => void;
}

const RegisterModalContext = createContext<RegisterModalContextValue | null>(null);

export function RegisterModalProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  return (
    <RegisterModalContext.Provider value={{ open, openModal: () => setOpen(true), closeModal: () => setOpen(false) }}>
      {children}
    </RegisterModalContext.Provider>
  );
}

export function useRegisterModal() {
  const ctx = useContext(RegisterModalContext);
  if (!ctx) throw new Error("useRegisterModal must be used inside RegisterModalProvider");
  return ctx;
}
